__turbopack_context__.v({
  "blok-big-title": "gallery-module__LY4A9a__blok-big-title",
  "blok-subtitle": "gallery-module__LY4A9a__blok-subtitle",
  "blok-title": "gallery-module__LY4A9a__blok-title",
  "booklet": "gallery-module__LY4A9a__booklet",
  "disabledButton": "gallery-module__LY4A9a__disabledButton",
  "gallery": "gallery-module__LY4A9a__gallery",
  "galleryButton": "gallery-module__LY4A9a__galleryButton",
  "galleryContainer": "gallery-module__LY4A9a__galleryContainer",
  "gallerySlide": "gallery-module__LY4A9a__gallerySlide",
  "img": "gallery-module__LY4A9a__img",
  "indicator": "gallery-module__LY4A9a__indicator",
  "indicators": "gallery-module__LY4A9a__indicators",
  "inner": "gallery-module__LY4A9a__inner",
  "left": "gallery-module__LY4A9a__left",
  "mediaGallery": "gallery-module__LY4A9a__mediaGallery",
  "right": "gallery-module__LY4A9a__right",
  "selected": "gallery-module__LY4A9a__selected",
  "thumbSlide": "gallery-module__LY4A9a__thumbSlide",
  "thumbSlideButton": "gallery-module__LY4A9a__thumbSlideButton",
  "thumbs": "gallery-module__LY4A9a__thumbs",
  "thumbsButton": "gallery-module__LY4A9a__thumbsButton",
  "thumbsContainer": "gallery-module__LY4A9a__thumbsContainer",
  "viewport": "gallery-module__LY4A9a__viewport",
});
